import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { GlassCard, Chip, Skeleton, Table, Pagination, PageHead } from "@/v2/admin/ui";
import { ScrollText, Search } from "lucide-react";

const TONE = (a) => (a.includes("حذف") ? "red" : a.includes("إيقاف") ? "gold" : a.includes("تصدير") ? "muted" : "emerald");

export default function Audit() {
  const [page, setPage] = useState(1);
  const [action, setAction] = useState("");
  const { data, isLoading } = useQuery({
    queryKey: ["adm-audit", page, action],
    queryFn: async () => (await api.get(`/admin/audit?page=${page}&limit=25&action=${encodeURIComponent(action)}`)).data,
  });
  const rows = data?.rows || [];

  return (
    <div className="space-y-5" data-testid="admin-audit">
      <PageHead icon={ScrollText} title="سجل الإدارة (Audit Log)" sub="كل إجراء إداري مسجَّل: من فعله، وماذا فعل، ومتى." />

      <div className="relative max-w-md">
        <Search size={16} className="absolute top-1/2 -translate-y-1/2 right-4 text-[#bcc8cf]" />
        <input value={action} onChange={(e) => { setAction(e.target.value); setPage(1); }} data-testid="audit-search"
          placeholder="ابحث في نوع الإجراء (حذف، تعديل، تصدير...)" className="v2-input" style={{ paddingInlineStart: "2.75rem" }} />
      </div>

      {isLoading ? <Skeleton className="h-72 w-full" /> : rows.length === 0 ? (
        <GlassCard className="p-10 text-center text-[#bcc8cf] text-sm">لا توجد سجلات مطابقة.</GlassCard>
      ) : (
        <Table head={["التاريخ والوقت", "المدير", "الإجراء", "النوع", "العنصر", "تفاصيل"]} min={820} testId="audit-table">
          {rows.map((r) => (
            <tr key={r.id} data-testid="audit-row">
              <td className="text-xs text-[#bcc8cf]" dir="ltr">{(r.at || "").slice(0, 16).replace("T", " ")}</td>
              <td className="font-semibold">{r.actor_name}</td>
              <td><Chip tone={TONE(r.action || "")}>{r.action}</Chip></td>
              <td className="text-[#bcc8cf]">{r.target_type}</td>
              <td className="max-w-[220px] truncate">{r.target}</td>
              <td className="text-xs text-[#bcc8cf] max-w-[240px] truncate">{r.details || "—"}</td>
            </tr>
          ))}
        </Table>
      )}

      <Pagination page={page} pages={data?.pages || 1} onChange={setPage} />
    </div>
  );
}
